import { Region } from '../partnership';

export const sortRegionByName = (regions: Region[]): Region[] => {
  return regions.sort((a, b) => (a.displayName ?? a.city).localeCompare(b.displayName ?? b.city));
};